// SIN&LACE – Mobile drawer: tap any item-with-children to toggle first, not navigate (Impulse)
(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 989px)").matches;
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!isMobile()) return;

      // Als je op de chevron/toggle klikt: laat Impulse z'n werk doen
      if (e.target.closest("#NavDrawer .mobile-nav__toggle")) return;

      // Pak klik op links/faux-links in de drawer (alle niveaus)
      var link = e.target.closest(
        "#NavDrawer .mobile-nav__link, #NavDrawer .mobile-nav__faux-link, #NavDrawer .mobile-nav__link--top-level"
      );
      if (!link) return;

      // Zoek het dichtstbijzijnde menu-item (li) waar een sublist onder hangt
      var item = link.closest("#NavDrawer .mobile-nav__item");
      if (!item) return;

      // Heeft dit item children?
      var sublist = item.querySelector(".mobile-nav__sublist");
      if (!sublist) return;

      // Vind de bijbehorende toggle knop (Impulse varianten)
      var toggleBtn =
        item.querySelector(".mobile-nav__toggle button") ||
        item.querySelector(".mobile-nav__toggle .faux-button") ||
        item.querySelector(".collapsible-trigger");

      if (!toggleBtn) return;

      // Bewuste "open in new tab" acties niet blokkeren
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

      // Bepaal of dit submenu al open staat
      var expanded =
        toggleBtn.getAttribute("aria-expanded") === "true" ||
        item.classList.contains("is-open") ||
        sublist.classList.contains("is-open");

      // Eerste klik: open submenu (geen doorklik)
      if (!expanded) {
        e.preventDefault();
        e.stopPropagation();
        toggleBtn.click();
      }
      // Tweede klik (als open): laat 'm wél navigeren
    },
    true // capture zodat we vóór default handlers zitten
  );
})();